module.exports = __webpack_public_path__ + "img/exitfullscreen.4ca17e78.svg";